// extracted by mini-css-extract-plugin
module.exports = {"dots":"BookOpenStatusChangePopup__dots"};